import { IgnitionLockExtension } from '../interfaces/vehicle';
import { TelemetryVehicle } from '../interfaces/telemetry';

export function isIgnitionLocked(vehicle: { extensions?: any; telemetry?: TelemetryVehicle | null }): boolean {
  const ext: IgnitionLockExtension | null = vehicle && vehicle.extensions && vehicle.extensions.IGNITION_LOCK || null;
  if (!ext || !vehicle.telemetry) {
    return false;
  }
  return vehicle.telemetry[ext.output] === true;
}
